import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useVoipRoomStore } from './voip-room-store'
import { useRoomLiveKit } from './room-live-kit.hook'

interface ClassroomJoiningReturn {
  isJoining: ComputedRef<boolean>
}

export const useClassroomJoining = (): ClassroomJoiningReturn => {
  const voipRoomStore = useVoipRoomStore()
  const { connectionState, isSupported } = useRoomLiveKit()

  const isConnectionPending = computed<boolean>(() =>
    connectionState.value === 'idle' || connectionState.value === 'connecting',
  )

  const isJoining = computed<boolean>(() =>
    !voipRoomStore.isAlternativeVoip && isSupported && isConnectionPending.value,
  )

  return { isJoining }
}
